function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class2;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Component, register, emitEvent } from 'ovee.js';
import { Swiper, Keyboard, EffectFade, Lazy, Navigation, Pagination, Autoplay, Virtual } from 'swiper';
Swiper.use([Keyboard, EffectFade, Lazy, Navigation, Pagination, Autoplay, Virtual]);

var _class = (_dec = register('slider-main'), _dec(_class2 = /*#__PURE__*/function (_Component) {
  _inherits(_class2, _Component);

  var _super = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "init",
    value: function init() {
      this.count = this.$element.querySelectorAll('.slider__slide').length;
      this.curr = 1;
      this.prepareDom();
      this.createSlider();
      this.bind();
    }
  }, {
    key: "prepareDom",
    value: function prepareDom() {
      var _container$querySelec;

      this.swiperContainer = this.$element.querySelector('.swiper-container');

      if (this.swiperContainer) {
        return;
      }

      var container = document.createElement('div');
      container.className = 'swiper-container';
      container.innerHTML = '<div class="swiper-wrapper"></div>';
      this.$element.appendChild(container);

      (_container$querySelec = container.querySelector('.swiper-wrapper')).append.apply(_container$querySelec, _toConsumableArray(this.$element.querySelectorAll('.slider__slide')));

      container.querySelectorAll('.slider__slide').forEach(function (slide, index) {
        slide.classList.add('swiper-slide');
        slide.dataset.slideNumber = index;
      });
      this.swiperContainer = container;
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var keyboard = true;
      var effect = 'slide';
      var speed = 600;
      var lazyload = !!this.swiperContainer.querySelector('.swiper-lazy');
      var lazy = lazyload ? {
        loadPrevNext: lazyload,
        loadPrevNextAmount: 2,
        checkInView: true
      } : false;
      var on = {
        lazyImageReady: function lazyImageReady(swiper, slideEl, imageEl) {
          imageEl.setAttribute('data-ll-status', 'loaded');
          imageEl.parentElement.classList.add('media-loaded');
          var slideIndex = slideEl.dataset.swiperSlideIndex;

          if (slideIndex) {
            var slides = swiper.slides;
            var duplicatedIDs = [];
            var i = 0;
            slides.forEach(function (slide) {
              if (slide.dataset.swiperSlideIndex === slideIndex) {
                duplicatedIDs.push(i);
              }

              i++;
            });

            if (duplicatedIDs) {
              duplicatedIDs.forEach(function (id) {
                swiper.lazy.loadInSlide(id);
              });
            }
          }
        },
        transitionEnd: function transitionEnd() {
          emitEvent(window, 'slide-change');
        },
        sliderFirstMove: function sliderFirstMove() {
          emitEvent(window, 'slide-drag');
        }
      };
      var navigation = {
        prevEl: this.$element.querySelector('.button--prev'),
        nextEl: this.$element.querySelector('.button--next')
      };
      var pagination = {
        el: this.$element.querySelector('.slider__pagination'),
        clickable: false,
        type: 'fraction',
        renderFraction: function renderFraction(currentClass, totalClass) {
          return "<span class=\"".concat(currentClass, "\"></span><span> OF </span><span class=\"").concat(totalClass, "\"></span>");
        },
        modifierClass: 'slider__pagination--',
        clickableClass: 'is-clickable'
      };
      return {
        keyboard: keyboard,
        effect: effect,
        speed: speed,
        preloadImages: !lazyload,
        lazy: lazy,
        navigation: navigation,
        pagination: pagination,
        on: on
      };
    }
  }, {
    key: "createSlider",
    value: function createSlider() {
      var options = this.getOptions();
      this.swiper = new Swiper(this.swiperContainer, options);
      this.$element.dataset.swiperInstance = this.swiper;
      this.$element.swiperInstance = this.swiper;
      this.$emit('sliderInitialized', this.swiper);
    }
  }, {
    key: "bind",
    value: function bind() {
      var _this = this;

      this.$on('imageload', 'img', function () {
        if (_this.swiper) {
          _this.swiper.update();
        }
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }]);

  return _class2;
}(Component)) || _class2);

export { _class as default };